import { Component, OnInit } from '@angular/core';
import { Title } from "@angular/platform-browser";
import { Router } from '@angular/router';
import { MessagecenterService } from 'src/app/services/messagecenter.service';
import { PatientService } from 'src/app/services/patient.service';
import { MenuItem, SelectItem } from 'primeng/api';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { common_message, DeleteMessage, full_message, full_message_sent, GetAllQuery, GetNewQuery, message_state, UpdateMessage } from '../../../models/message';
import { PromiseResult, ServerError } from '../../../models/PromiseResult';
import { HttpErrorResponse } from '@angular/common/http';
import { TraceClassDecorator } from '@sentry/angular';
import { roles } from '../../../constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@Component({
    selector: 'app-messagecenter',
    templateUrl: './messagecenter.component.html',
    styleUrls: ['../../../../assets/css/custom-egd.css', 'messagecenter.component.css']
})
@TraceClassDecorator()
export class MessagecenterComponent implements OnInit {

    patientValue: string = "All";
    members: SelectItem[] = [];
    messageCount: number;
    count: number = 0;
    term: string;
    member_value = "0";
    page_no: number;
    readonly messages_per_page: number;
    total_message_count: number;
    init: boolean = true;
    MailChecking: boolean;
    slug: string = "";
    private readonly user_guid: string;
    constructor(private router: Router, private patientservice: PatientService, private titleService: Title, private messageService: MessagecenterService,
        private breadcrumbService: BreadcrumbService,
        private readonly providerStateService: ProviderStateService) {

        this.messages_per_page = 10;
        this.page_no = 1;
        this.sentEnabled = false;
        this.messageCount = 0;
        this.total_message_count = 0;
        this.selected = false;
        this.MailChecking = false;
        this.user_guid = sessionStorage.getItem('userid');
        this.flagged = null;
        this.user = roles.patient;
    }

    selected: boolean;
    messages: common_message[] = [];
    sentEnabled: boolean;
    response: PromiseResult;
    serverError: ServerError;
    items: MenuItem[];
    flagged: boolean;
    private readonly user: roles;
    private async getMemberList(): Promise<void> {
        this.MailChecking = true;
        await this.ResetResultModels();
        await this.patientservice.getMember(this.user_guid).toPromise().then((result: PromiseResult) => {

            this.response = result;
            if (result.success) {
                const temp: SelectItem[] = [];

                for (let i = 0; i < result.data.patient.length; i++) {
                    temp.push(
                        {
                            label: result.data.patient[i].first_name + " " + (result.data.patient[i].middle_name == null ? '' : result.data.patient[i].middle_name) + " " + result.data.patient[i].last_name,
                            value: result.data.patient[i].patient_guid
                        }
                    )
                }
                this.members = temp;
                this.member_value = result.data.patient[0].patient_guid;

            }
            this.MailChecking = false;

        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.MailChecking = false;
            this.response.success = false;
        })
    }

    async onMemberChange(): Promise<void> {
        this.messages = [];
        this.total_message_count = 0;
        await this.GetMessageList();

    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: ['/', this.slug, 'patient'] },
            { label: 'Message Center' },
        ]);
        this.titleService.setTitle("Dashboard - Message Center");
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };

        this.items = [

            {
                label: 'Filter',
                icon: 'pi pi-filter',
                items:
                    [
                        {
                            label: 'All',
                            command: async () => {
                                await this.Filter(message_state.all);
                            }
                        },
                        {
                            label: 'Flagged',
                            command: async () => {
                                await this.Filter(message_state.flagged);
                            }
                        },

                    ]
            },
            {
                label: 'Action',
                icon: 'pi pi-check-square',
                items:
                    [
                        {
                            label: 'Flag',
                            icon: 'pi pi-fw pi-star',
                            command: async () => {
                                await this.FlagMessages(true);
                            },

                        },
                        {
                            label: 'Unflag',
                            icon: 'pi pi-fw pi-star-o',
                            command: async () => {
                                await this.FlagMessages(false);
                            },

                        },
                        {
                            label: 'Mark as Read',
                            icon: 'pi pi-fw pi-circle-off',
                            command: async () => {
                                await this.markAsRead();
                            },

                        },
                        {
                            label: 'Mark as Unread',
                            icon: 'pi pi-fw pi-circle-on',
                            command: async () => {
                                this.markAsUnRead();
                            },

                        },
                        {
                            label: 'Delete',
                            icon: 'pi pi-fw pi-trash',
                            command: async () => {
                                await this.DeleteSelectedMessages();
                            },

                        }
                    ]
            },

        ];
        await this.getMemberList();
        await this.GetMessageList();
    }

    private async ChangeMenuItems(): Promise<void> {
        if (this.sentEnabled) {
            this.items = [

                {
                    label: 'Filter',
                    icon: 'pi pi-filter',
                    items:
                        [
                            {
                                label: 'All',
                                command: async () => {
                                    await this.Filter(message_state.all);
                                }
                            },
                            {
                                label: 'Flagged',
                                command: async () => {
                                    await this.Filter(message_state.flagged);
                                }
                            },

                        ]
                },
                {
                    label: 'Action',
                    icon: 'pi pi-check-square',
                    items:
                        [
                            {
                                label: 'Flag',
                                icon: 'pi pi-fw pi-star',
                                command: async () => {
                                    await this.FlagMessages(true);
                                },

                            },
                            {
                                label: 'Unflag',
                                icon: 'pi pi-fw pi-star-o',
                                command: async () => {
                                    await this.FlagMessages(false);
                                },

                            },

                        ]
                },

            ];
        }
        else {
            this.items = [

                {
                    label: 'Filter',
                    icon: 'pi pi-filter',
                    items:
                        [
                            {
                                label: 'All',
                                command: async () => {
                                    await this.Filter(message_state.all);
                                }
                            },
                            {
                                label: 'Flagged',
                                command: async () => {
                                    await this.Filter(message_state.flagged);
                                }
                            },

                        ]
                },
                {
                    label: 'Action',
                    icon: 'pi pi-check-square',
                    items:
                        [
                            {
                                label: 'Flag',
                                icon: 'pi pi-fw pi-star',
                                command: async () => {
                                    await this.FlagMessages(true);
                                },

                            },
                            {
                                label: 'Unflag',
                                icon: 'pi pi-fw pi-star-o',
                                command: async () => {
                                    await this.FlagMessages(false);
                                },

                            },
                            {
                                label: 'Mark as Read',
                                icon: 'pi pi-fw pi-circle-off',
                                command: async () => {
                                    await this.markAsRead();
                                },

                            },
                            {
                                label: 'Mark as Unread',
                                icon: 'pi pi-fw pi-circle-on',
                                command: async () => {
                                    await this.markAsUnRead();
                                },

                            },
                            {
                                label: 'Delete',
                                icon: 'pi pi-fw pi-trash',
                                command: async () => {
                                    await this.DeleteSelectedMessages();
                                },

                            }
                        ]
                },

            ];
        }
    }

    async TabSwitch(sent_value: boolean): Promise<void> {
        this.flagged = false;
        this.selected = false;
        this.page_no = 1;
        this.messageCount = 0;
        this.total_message_count = 0;
        await this.ChangeMenuItems();
        if (this.sentEnabled != sent_value) {
            this.sentEnabled = sent_value;
            await this.GetMessageList();
        }


    }

    async ResetResultModels(): Promise<void> {
        this.response.success = null;
        this.response.error = null;
        this.response.data = null;
        this.serverError.message = null;
        this.serverError.error = null;
    }

    MailViewNavigation(patient_guid: string, message_id: number, user_guid: string): void {
        const route = patient_guid + "/" + message_id + "/" + user_guid + "/" + (this.sentEnabled ? 'true' : 'false');

        this.router.navigate(['/' + this.slug + '/patient/mailview/' + route]);
    }


    async GetMessageList(): Promise<void> {
        this.MailChecking = true;
        const query: GetAllQuery = {
            patient_guid: this.member_value,
            sent: this.sentEnabled,
            flagged: this.flagged,
            page_no: this.page_no,
            messages_per_page: this.messages_per_page
        }
        this.messageCount = 0;
        this.messages = [];
        await this.ResetResultModels();
        await this.messageService.GetAllMessages(query, this.user).toPromise().then((result: PromiseResult) => {
            this.response = result;
            if (result.success) {

                if (this.sentEnabled) {
                    const all: full_message_sent[] = result.data.rows;
                    const temp: common_message[] = [];
                    for (const message of all) {
                        temp.push(
                            {
                                id: this.messageCount++,
                                to: message.egd_users.first_name + " " + (message.egd_users.middle_name == null ? '' : message.egd_users.middle_name) + " " + message.egd_users.last_name,
                                subject: message.messages.subject,
                                date: message.messages.created_at,
                                patient_guid: this.member_value,
                                user_guid: message.user_guid,
                                message_id: message.messages.id,
                                flagged: message.messages.flagged,
                                read: true,
                                selected: false
                            }
                        )
                    }
                    this.messages = temp;
                }
                else {
                    const all: full_message[] = result.data.rows;
                    const temp: common_message[] = [];
                    for (const message of all) {
                        temp.push(
                            {
                                id: this.messageCount++,
                                from: message.messages.egd_users.first_name + " " + (message.messages.egd_users.middle_name == null ? '' : message.messages.egd_users.middle_name) + " " + message.messages.egd_users.last_name,
                                subject: message.messages.subject,
                                date: message.messages.created_at,
                                patient_guid: this.member_value,
                                user_guid: message.messages.user_guid,
                                message_id: message.messages.id,
                                flagged: message.flagged,
                                read: message.read,
                                selected: false
                            }
                        )
                    }
                    this.messages = temp;
                }
                this.total_message_count = result.data.count;
            }
            else {
                this.total_message_count = 0;
            }



            this.MailChecking = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.MailChecking = false;
            this.response.success = false;
        })

    }
    // delete existing using map
    private async DeleteMessages(message_id: number[]): Promise<void> {
        const query: DeleteMessage = {
            messages_per_page: this.messages_per_page,
            page_no: this.page_no,
            message_id: message_id
        }
        this.MailChecking = true;
        await this.ResetResultModels();
        await this.messageService.DeleteMessages(query, this.user, null, this.member_value).toPromise().then((result: PromiseResult) => {
            this.response = result;
            if (result.success) {
                const all: full_message[] = result.data.rows;
                const temp: common_message[] = [];
                let message_id_counter = 0;

                for (const message of this.messages) {
                    if (message_id_counter < message_id.length && message.message_id == message_id[message_id_counter]) {
                        message_id_counter++;
                    }
                    else {
                        temp.push(message);
                    }
                }
                for (const message of all) {
                    temp.push(
                        {
                            id: this.messageCount++,
                            from: message.messages.egd_users.first_name + " " + (message.messages.egd_users.middle_name == null ? '' : message.messages.egd_users.middle_name) + " " + message.messages.egd_users.last_name,
                            subject: message.messages.subject,
                            date: message.messages.created_at,
                            patient_guid: this.member_value,
                            user_guid: message.user_guid,
                            message_id: message.messages.id,
                            flagged: message.flagged,
                            read: message.read,
                            selected: false
                        }
                    )

                }
                this.messages = [];
                this.messages = temp;
                this.total_message_count = result.data.count;

            }
            this.MailChecking = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.MailChecking = false;
            this.response.success = false;
        })
    }


    async GetUpdates(): Promise<void> {
        if (this.page_no == 1) {
            this.MailChecking = true;
            const query: GetNewQuery = {
                patient_guid: this.member_value,
                total_messages: this.total_message_count,
                sent: this.sentEnabled
            }
            await this.ResetResultModels();
            await this.messageService.GetNewMessage(query, this.user).toPromise().then((result: PromiseResult) => {
                this.response = result;
                if (result.success) {

                    if (this.sentEnabled) {
                        const all: full_message_sent[] = result.data.rows;
                        //all.reverse()
                        const temp: common_message[] = this.messages;
                        for (const message of all) {
                            temp.unshift(
                                {
                                    id: this.messageCount++,
                                    to: message.egd_users.first_name + " " + (message.egd_users.middle_name == null ? '' : message.egd_users.middle_name) + " " + message.egd_users.last_name,
                                    subject: message.messages.subject,
                                    date: message.messages.created_at,
                                    patient_guid: this.member_value,
                                    user_guid: message.user_guid,
                                    message_id: message.messages.id,
                                    flagged: message.messages.flagged,
                                    read: true,
                                    selected: false
                                }
                            )
                            if (temp.length > this.messages_per_page) temp.pop();
                        }
                        this.messages = [];
                        this.messages = temp;
                    }
                    else {
                        const all: full_message[] = result.data.rows;
                        //all.reverse();
                        const temp: common_message[] = this.messages;
                        for (const message of all) {
                            temp.unshift(
                                {
                                    id: this.messageCount++,
                                    from: message.messages.egd_users.first_name + " " + (message.messages.egd_users.middle_name == null ? '' : message.messages.egd_users.middle_name) + " " + message.messages.egd_users.last_name,
                                    subject: message.messages.subject,
                                    date: message.messages.created_at,
                                    patient_guid: this.member_value,
                                    user_guid: message.messages.user_guid,
                                    message_id: message.messages.id,
                                    flagged: message.flagged,
                                    read: message.read,
                                    selected: false
                                }
                            )
                            if (temp.length > this.messages_per_page) temp.pop();

                        }
                        this.messages = [];
                        this.messages = temp;
                    }
                    this.total_message_count = result.data.count;
                }

                this.MailChecking = false;
            }).catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.MailChecking = false;
                this.response.success = false;
            })
        }

    }





    public minFn(a: number, b: number): number {
        return Math.min(a, b);
    }

    async nextPage(): Promise<void> {

        if (this.page_no * this.messages_per_page < this.total_message_count) {
            this.page_no++;
            await this.GetMessageList();
        }


    }

    async prevPage(): Promise<void> {

        if (this.page_no > 1) {
            this.page_no--;
            await this.GetMessageList();
        }

    }





    private async updateMessage(message_id: number[], flagged: boolean, read_value: boolean): Promise<void> {
        this.MailChecking = true;
        await this.ResetResultModels();
        const query: UpdateMessage = {
            message_id: message_id,
            flagged: flagged,
            read_value: read_value,
            sent: this.sentEnabled
        }
        await this.messageService.UpdateMessages(query, this.user, null, this.member_value).toPromise().then((result: PromiseResult) => {
            this.response = result;
            if (result.success) {
                if (this.sentEnabled) {
                    if (flagged != null) {
                        let msg_id_counter = 0;
                        for (const message of this.messages) {
                            if (msg_id_counter < message_id.length && message.message_id == message_id[msg_id_counter]) {
                                message.flagged = flagged;
                                msg_id_counter++;
                            }
                        }
                    }
                }
                else {
                    if (flagged != null) {
                        let msg_id_counter = 0;
                        for (const message of this.messages) {
                            if (msg_id_counter < message_id.length && message.message_id == message_id[msg_id_counter]) {
                                message.flagged = flagged;
                                msg_id_counter++;
                            }
                        }
                    }
                    else if (read_value != null) {
                        let msg_id_counter = 0;
                        for (const message of this.messages) {
                            if (msg_id_counter < message_id.length && message.message_id == message_id[msg_id_counter]) {
                                message.read = read_value;
                                msg_id_counter++;
                            }
                        }
                    }
                }
            }
            this.MailChecking = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.MailChecking = false;
            this.response.success = false;
        })
    }











    async selectALL(): Promise<void> {

        this.selected = !this.selected;

        for (let i = 0; i < this.messages.length; i++) {
            //this.messages[i].checked=this.selected?true:false;
            if (this.selected) {
                this.messages[i].selected = true;
            }
            else {
                this.messages[i].selected = false;
            }

        }

        this.count = this.selected ? this.messageCount : 0;

    }

    async select(id: number): Promise<void> {
        this.messages[id].selected = !this.messages[id].selected;

        if (this.messages[id].selected == true) {
            this.count++;
        }
        else {
            this.count--;
        }
        if (this.count == this.messages.length) {
            this.selected = true;
        }
        else {
            this.selected = false;
        }
        this.count = Math.min(this.count, this.messages.length);

    }

    async DeleteSelectedMessages(): Promise<void> {
        const selected_list = [];
        for (const message of this.messages) {
            if (message.selected) {
                selected_list.push(message.message_id);
            }
        }
        if (selected_list.length > 0 && !this.sentEnabled) {
            await this.DeleteMessages(selected_list);
        }
    }

    async markAsRead(): Promise<void> {
        const selected_list = [];

        for (let i = 0; i < this.messages.length; i++) {
            if (this.messages[i].selected == true) {
                //this.messages[i].read=true;
                selected_list.push(Number(this.messages[i].message_id));
            }
        }
        if (selected_list.length > 0 && !this.sentEnabled) {

            await this.updateMessage(selected_list, null, true);
        }

    }
    async markAsUnRead(): Promise<void> {
        const selected_list = [];

        for (let i = 0; i < this.messages.length; i++) {
            if (this.messages[i].selected == true) {
                //this.messages[i].read=false;
                selected_list.push(Number(this.messages[i].message_id));
            }
        }
        if (selected_list.length > 0 && !this.sentEnabled) {
            await this.updateMessage(selected_list, null, false);

        }

    }

    async FlagMessages(flag_value: boolean): Promise<void> {
        const selected_list = [];
        for (const message of this.messages) {
            if (message.selected) {
                selected_list.push(message.message_id);
            }
        }
        if (selected_list.length > 0) {
            await this.updateMessage(selected_list, flag_value, null);

        }
    }

    async Filter(cmd: string): Promise<void> {
        this.page_no = 1;
        this.messageCount = 0;
        this.total_message_count = 0;
        if (cmd == message_state.all) {
            this.flagged = null;
        }
        else if (cmd == message_state.flagged) {
            this.flagged = true;
        }
        await this.GetMessageList();
    }

    // // applyFilter(event: Event) {
    // //     const filterValue = (event.target as HTMLInputElement).value;
    // //     this.dataSource.filter = filterValue.trim().toLowerCase();

    // //     if (this.dataSource.paginator) {
    // //       this.dataSource.paginator.firstPage();
    // //     }
    // //   }

    // SetTitle(title:string){
    //     // let Title=this.titleService.getTitle().split(" ");
    //     // let notif=Title[0].substr(1,Title[0].length-2);
    //     this.titleService.setTitle(title);

    // }

}
